import {Helmet} from '@dr.pogodin/react-helmet';

import {UserAbsenceOverviewGrid} from '@dms/features/user-absence';
import i18n from '@dms/i18n';
import {Main, usePermissions} from '@dms/shared';

import {openUserAbsenceCreateDialog} from './components/openUserAbsenceCreateDialog';

export function UserAbsenceOverview() {
  const [canCreateUserAbsence] = usePermissions({
    permissionKeys: ['userAbsenceCreate'],
    scopes: {
      userAbsenceCreate: {
        // General creation, not scoped to a branch
        branchId: 'SKIP',
      },
    },
  });

  return (
    <>
      <Helmet title={i18n.t('user.awayStatus.awayBadge')} />
      <Main
        isFullHeight
        heading={i18n.t('user.awayStatus.awayBadge')}
        data-testid="employee-user-absence-overview"
        actions={
          canCreateUserAbsence
            ? [
                {
                  type: 'button',
                  title: `${i18n.t('general.actions.add')} ${i18n.t('user.awayStatus.awayBadge')}`,
                  onClick: () =>
                    openUserAbsenceCreateDialog({
                      'data-testid': 'employee-user-absence-overview',
                    }),
                },
              ]
            : undefined
        }
      >
        <UserAbsenceOverviewGrid data-testid="employee-user-absence-overview-grid" />
      </Main>
    </>
  );
}
